import React, { useEffect } from "react";
import { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { Avatar } from "@mui/material";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import apiClient from "../api/apiClient";
import { useSelector } from "react-redux";
import { object } from "underscore";
import { toast } from "react-toastify";

const SellerPayments = () => {
  const { token, userType, isLoggedIn, userid } = useSelector(
    (state) => state.auth
  );
  const { profiledata, fetchDataprofile } = useIndexPageData();
  const [avatarSrc, setAvatarSrc] = useState("");
  // const [selectedOption, setSelectedOption] = useState('');
  const [Edit, setEdit] = useState(false);
  const [loader, setloader] = useState(false);

  //   const handleOptionChange = (event) => {
  //     setSelectedOption(event.target.value);
  //   };

  const [profileupdate, setprofileupdate] = useState({
    full_name: "",
    profile: "",
  });
  const handleonchange = (key, value) => {
    setprofileupdate((pre) => ({ ...pre, [key]: value }));
  };

  const handleUploadClick = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    const formData = new FormData();
    if (file) {
      formData.append("profile", file);
    }

    postprofiledata(formData);

    handleonchange("profile", file);

    reader.onloadend = () => {
      setAvatarSrc(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const postprofiledata = async (formdata) => {
    // Assuming profileupdate is defined elsewhere in your code
    // const formData = new FormData();
    // formData.append('full_name', profileupdate.full_name);

    // if(typeof profileupdate.profile=="object" && profileupdate.profile ){

    //     formData.append('profile', profileupdate.profile);
    // }

    if (!userid) return;

    try {
      setloader(true);
      const result = await apiClient.put(`/register/${userid}/`, formdata);
      setloader(false);
      if (result.ok) {
        fetchDataprofile();
        toast.success("Profile updated successfully");
      } else {
      }
    } catch (error) {
      console.error("Error updating profile:", error.message);
    }
  };

  useEffect(() => {
    setprofileupdate(profiledata);
  }, [profiledata.full_name]);

  const handleEdit = () => {
    setEdit(!Edit);
  };

  const handleBlur = () => {
    const formData = new FormData();
    formData.append("full_name", profileupdate?.full_name);
    if (profileupdate?.full_name !== profiledata?.full_name) {
      postprofiledata(formData);
    }
  };
  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-5 mb-2">
              <h2 className=" mb-3" style={{ color: "#000000e6" }}>
                Billing Information
              </h2>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="row">
          <div className="col">
            <div
              className="p-4"
              style={{ backgroundColor: "#F5F7F8", borderRadius: "12px" }}
            >
              <h5 className="fw-bold mb-3" style={{ color: "#000000e6" }}>
                Connect Your Stripe Account
              </h5>

              <div className="row">
                <div className="col-12">
                  <div
                    className="d-flex align-items-center gap-3 p-3 bg-white shadow"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="flex-shrink-0">
                      <img
                        src="../assets/images/stripe.png"
                        style={{ width: "45px", height: "auto" }}
                        alt="Stripe"
                      />
                    </div>
                    <div className="flex-grow-1">
                      <p
                        className="mb-1 fw-bold"
                        style={{ fontSize: "16px", color: "#000000e6" }}
                      >
                        Stripe Payment Gateway
                      </p>
                      <p
                        className="mb-0"
                        style={{ fontSize: "14px", color: "#666" }}
                      >
                        Complete the Stripe form to recieve payments from your
                        mockup sales
                      </p>
                    </div>
                    <div className="flex-shrink-0">
                      <button
                        disabled={loader}
                        className="btn grey-btn"
                        style={{ minWidth: "100px" }}
                      >
                        {loader ? "Managing..." : "Manage"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellerPayments;
